/* eslint-disable react/prop-types */
import { useState, useEffect, useCallback } from 'react';
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';
import axios from 'axios';
import Footer from "../components/footer/Footer";
import Header from "../components/header/Header";
import AccountTabs from '../components/my-account/AccountTabs';
import Loader from '@/components/util/Loader';

export default function MyAccount({countries}) {
  const [userData, setUserData] = useState(null);
  const [activeTab, setActiveTab] = useState('my-details');
  const [isLoading, setIsLoading] = useState(false);
  const router = useRouter();

  useEffect(() => {
    if (router.query.tab) {
      setActiveTab(router.query.tab);
    }
  }, [router.query.tab]);

  const fetchUserData = useCallback(async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      if (!localStorage.getItem('redirectUrl')) {
        const redirectPath = router.query.tab
          ? `${window.location.pathname}?tab=${router.query.tab}`
          : window.location.pathname;
        localStorage.setItem('redirectUrl', redirectPath);
      }
      router.push('/login').catch(() => {
        setIsLoading(false);
      });
      return;
    }

    try {
      const response = await fetch('/api/user', {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        setUserData(data);
      } else {
        if (!localStorage.getItem('redirectUrl')) {
          const redirectPath = router.query.tab
            ? `${window.location.pathname}?tab=${router.query.tab}`
            : window.location.pathname;
          localStorage.setItem('redirectUrl', redirectPath);
        }
        localStorage.removeItem('token');
        router.push('/login').catch(() => {
          setIsLoading(false);
        });
      }
    } catch (error) {
      console.error('An error occurred', error);
    }
  }, [router]);

  useEffect(() => {
    fetchUserData();
  }, [fetchUserData]);

  const t = useTranslations('Account');

  if (!userData) return <Loader />;

  return (
    <>
      <Header title={t('my_account')} />
      <main className="py-0 md:py-10 px-2 md:px-0 min-h-screen login-register-background">
        <div className="container mx-auto py-24 md:py-36 min-h-screen login-register-background">
          <AccountTabs userData={userData} fetchUserData={fetchUserData} countries={countries} activeTab={activeTab} isLoading={isLoading} setIsLoading={setIsLoading} router={router} />
        </div>
      </main>
      <Footer />
    </>
  );
}

export async function getStaticProps() {
  const { data } = await axios.get(`${process.env.NEXT_PUBLIC_WORDPRESS_SITE_URL}wp-json/beaver_next_wordpress/v1/settings`);
  const { data: countries } = await axios.get(`${process.env.NEXT_PUBLIC_WORDPRESS_SITE_URL}wp-json/beaver_next_wordpress/v1/countries`);
  const { data: studioData } = await axios.get(`${process.env.NEXT_PUBLIC_WORDPRESS_SITE_URL}wp-json/beaver_next_wordpress/v1/acf_studio`);

  let lang = 'en';

  if (data?.language) {
    lang = data.language.split('_')[0];
  }

  const messages = await import(`../messages/${lang}.json`);

  return {
    props: {
      data: data || {},
      messages: messages.default,
      countries: countries,
      studioData: studioData || {},
    },
    revalidate: 300,
  };
}
